<script>
    import {_, number, locale} from 'svelte-i18n';
    import Item from './Item.svelte';
    import {gameConfig, user} from "../../stores.js";
    import {
        shipBlueprintIcon, shipBlueprintKeys, sideSuffix, artSideSuffix, resolveTitle,
    } from './naval-items.js';

    let { item, gameItem } = $props();
    let itemDetails = $state({});

    function setItemDetails() {
        // Blueprint names are faction specific — ship 1 is "USS Harriet Lane" for
        // North and "CSS Nashville" for South — so the player's side selects the row.
        const baseId = Number(gameItem.baseId);
        const side = sideSuffix($user?.user?.side);
        const keys = shipBlueprintKeys(baseId, side);
        // shipBlueprint entries carry no amount; one item is one blueprint.
        const points = Number(gameItem.amount) || 1;

        itemDetails.title = resolveTitle({
            key: keys.title,
            fallback: 'Ship Blueprint',
            translate: (k) => $_(k, {values: {POINTS: $number(points)}}),
        });
        itemDetails.description = resolveTitle({
            key: keys.description,
            fallback: '',
            translate: (k) => $_(k, {values: {POINTS: $number(points)}}),
        });
        itemDetails.amount = item.amount;
        // Art uses its own side rule — a sideless player gets North, not the wrong
        // faction. The loc keys above keep sideSuffix(). See artSideSuffix().
        itemDetails.icon = shipBlueprintIcon(baseId, artSideSuffix($user?.user?.side));
        // These entries carry no rarity, and an undefined one would interpolate
        // into the icon's class list; 'default' is the existing neutral plate.
        itemDetails.rarityClass = 'default';
        itemDetails.expireAt = $gameConfig?.temporaryItems?.[item.id];
        itemDetails.claimed = item.claimed;
    }

    $effect(() => {
        $locale;
        setItemDetails();
    });
</script>

<Item {itemDetails}/>
